import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AppGuard } from './services/auth.guard';
import { InserirInformacoesLaudoComponent } from './pages/inserir-informacoes-laudo/inserir-informacoes-laudo.component';
import { VisualizarLaudoComponent } from './pages/laudo-higienizacao/visualizar-laudo/visualizar-laudo.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';

const routes: Routes = [
  { path: '', redirectTo: 'inserir-informacoes-laudo', pathMatch: 'full' },
  {
    path: 'inserir-informacoes-laudo',
    component: InserirInformacoesLaudoComponent
  },
  {
    path: 'visualizar-laudo',
    component: VisualizarLaudoComponent
  },
  {
    path: '**',
    component: NotFoundComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
